import Http from '../libs/http';
import { entryCountMap, validityPeriodMap } from '../constants/product-constants';
import utils from '../libs/utils';

export default {

  /**
   * 获取回寄快递费用
   * @param {Object} productID 供应商地址
   * @param {Number} provienceCode 长期居住地省
   */
  visaProductReturnExpressPriceDetect(productID, provienceCode) {
    return Http.post('/sys/visa_product_return_express_price_detect', {
      visa_product_id: productID,
      province_code: provienceCode,
    });
  },

  /**
   * 获取邮寄来源
   * @param {Object} pcds 省市区数据
   * @param {Number} provinceCode 供应商省
   * @param {Number} cityCode 供应商市
   */
  setReturnExpressFrom(pcds, provinceCode, cityCode) {
    if (provinceCode && pcds && pcds['86'] && cityCode) {
      const province = pcds['86'][provinceCode];
      const city = pcds[provinceCode][cityCode];
      return `${province}${city}`;
    }
    return '';
  },

  /**
   * 提交回寄地址信息
   * @param {Number} orderId 订单号
   * @param {Object} selectedReturnAddress 选中的回寄地址
   */
  orderReturnExpressSubmit(orderId, selectedReturnAddress) {
    return Http.post('/order_return_address_submit', {
      user_order_id: orderId,
      peer_address_id: selectedReturnAddress.peer_address_id,
    });
  },

  /**
   * 查询商品可用优惠券
   * @param {Number} visaProductID 商品 ID
   */
  visaProductCoupon(visaProductID) {
    return Http.post('/visa_product_coupon_query', {
      visa_product_id: visaProductID,
    });
  },


  // 获取入境次数中文
  getEntryCountCN(num, unit) {
    if (unit === 0) {
      // 次数
      return `${num === 1 ? '单' : num}${entryCountMap[unit]}`;
    }
    return entryCountMap[unit] || '';
  },

  // 获取入境次数中文
  getValidityPeriodCN(num, unit) {
    if ([0, 1, 2].indexOf(unit) > -1) {
      // 次数
      return `${num}${unit === 1 ? '个' : ''}${validityPeriodMap[unit]}`;
    }
    return validityPeriodMap[unit] || '';
  },


  // 获取商品价格
  getPrice(price) {
    if (!price) return 0;
    const dealPrice = utils.divide(price, 100);
    if (Number.isInteger(dealPrice)) {  
      return dealPrice;
    }
    const decimalNumber = dealPrice.toString().split('.')[1].slice(0, 2);
    const result = `${dealPrice.toString().split('.')[0]}.${decimalNumber}`;
    return parseFloat(result);
  },
  // 获取商品销售价格
  getSalesPrice(visaDetail) {
    if (!visaDetail) return 0;
    let price = visaDetail.peer_price;
    if (visaDetail.special_price !== undefined) {
      price = visaDetail.special_price;
    } else if (visaDetail.after_coupon_price !== undefined) {
      price = visaDetail.after_coupon_price;
    } 
    return this.getPrice(price);
  },

};



// WEBPACK FOOTER //
// ./src/services/product-service.js